import axios from 'axios';

const getMlsStaffDataConnectBoardIds = async (
  mlsStaffOrgId: string,
): Promise<string[]> => {
  const { data } = await axios.get<string[]>(
    `/supra/${mlsStaffOrgId}/data_connect_board_ids`,
  );

  return data;
};

export default getMlsStaffDataConnectBoardIds;
